import { Page } from '../../types'

const briberyInvestigations: Page[] = [
    {
        pageType: 'question',
        title: 'Bribery Investigations',
        name: 'bribery-investigations',
        questions: [
            {
                questionType: 'instanceInput',
                title: 'How many investigations were brought forward?',
                name: 'bribery-investigations-brought-forward',
                hint: 'Total number of instances',
                rules: {
                    required: false
                }
            },
            {
                questionType: 'instanceInput',
                title: 'How many investigations were opened?',
                name: 'bribery-investigations-opened',
                hint: 'Total number of instances',
                rules: {
                    required: false
                }
            },
            {
                questionType: 'instanceInput',
                title: 'How many investigations were closed?',
                name: 'bribery-investigations-closed',
                hint: 'Total number of instances',
                rules: {
                    required: false
                }
            },
            {
                questionType: 'instanceInput',
                title: 'How many investigations were ongoing?',
                name: 'bribery-investigations-ongoing',
                hint: 'Total number of instances',
                rules: {
                    required: false
                }
            },
            {
                questionType: 'textarea',
                title: 'Comments',
                name: 'bribery-investigations-text-comments',
                hint: 'Please ensure you do not include any personal or sensitive information',
                rules: {
                    required: false
                }
            }
        ]
    },
]
export default briberyInvestigations
